import React from 'react';
import { Sun, CheckCircle2, Phone, MessageSquare, Mail } from 'lucide-react';
import { SocialProofBar } from '../../components/SocialProofBar';
import { SITE_IMAGES } from '../../components/siteImages';
import { CAMP_SEASON } from './summerCampContent';
export function SummerCampHero() {
  return <section className="relative bg-ink pt-12 pb-24 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-3192">
      <div className="absolute inset-0 opacity-70" data-id="element-3193">
        <img src={SITE_IMAGES.summerCamp} alt="Storm Taekwondo summer camp in Farmington Hills" className="block w-full h-full object-cover" data-id="element-3194" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/70 to-ink/20" data-id="element-3195" />
      </div>

      <div className="absolute top-0 right-0 w-1/3 h-full bg-storm-red transform skew-x-12 translate-x-32 opacity-10 pointer-events-none" data-id="element-3196" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-3197">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-3198">
          <div className="flex flex-col items-start" data-id="element-3199">
            <div className="inline-flex items-center gap-2 bg-storm-red text-white px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-6" data-id="element-3200">
              <Sun className="w-4 h-4" data-id="element-3201" />
              Summer Camp {CAMP_SEASON.year}
            </div>

            <div className="mb-8" data-id="element-3202">
              <SocialProofBar showFreeWeek={false} data-id="element-3203" />
            </div>

            <h1 className="text-5xl md:text-6xl text-white mb-4 leading-[1.05]" data-id="element-3204">
              Active Kids <span className="text-storm-red" data-id="element-3205">Summer Camp</span> in
              Farmington Hills
            </h1>

            <p className="font-display text-2xl md:text-3xl text-gold mb-6 tracking-wide uppercase" data-id="element-3206">
              {CAMP_SEASON.theme}
            </p>

            <p className="text-xl text-off-white mb-8 max-w-xl leading-relaxed" data-id="element-3207">
              A fun, active kids camp hosted inside the Storm Taekwondo facility
              with games, movement, structured activities, and taekwondo-themed
              fun. Not a formal Taekwondo class — just a great way for kids to
              spend their summer.
            </p>

            <ul className="flex flex-col gap-3 mb-10" data-id="element-3208">
              {['Weekly sessions, June through August', 'Ages 6 and up', 'Monday–Friday, 10:00 AM – 4:00 PM', 'Storm Taekwondo shirt included'].map((item, idx) => <li key={idx} className="flex items-center gap-3 text-white text-lg" data-id="element-3209">
                  <CheckCircle2 className="w-6 h-6 text-storm-red shrink-0" data-id="element-3210" />
                  <span data-id="element-3211">{item}</span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto" data-id="element-3212">
              <a href={`sms:${CAMP_SEASON.registrationPhone.replace(/-/g, '')}`} className="btn-primary" data-id="element-3213">
                Text To Register
              </a>
              <a href={`tel:${CAMP_SEASON.registrationPhone}`} className="btn-secondary" data-id="element-3214">
                <Phone className="w-5 h-5 mr-2" data-id="element-3215" />
                Call {CAMP_SEASON.registrationPhone}
              </a>
            </div>
          </div>

          {/* Registration Card */}
          <div className="w-full max-w-md mx-auto lg:mx-0 lg:ml-auto" data-id="element-3216">
            <div className="bg-paper p-8 rounded-2xl shadow-2xl border border-subtle-gray relative" data-id="element-3217">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-storm-red text-white px-6 py-2 rounded-full font-bold uppercase tracking-wide whitespace-nowrap shadow-lg text-sm" data-id="element-3218">
                Register Today
              </div>

              <div className="mt-4" data-id="element-3219">
                <h2 className="text-3xl text-ink text-center mb-2" data-id="element-3220">
                  Text or Call Megan
                </h2>
                <p className="text-gray-warm text-center text-sm mb-6" data-id="element-3221">
                  The fastest way to lock in a camp spot is to text or call
                  directly. Megan will confirm dates, pricing and any details.
                </p>

                <a href={`tel:${CAMP_SEASON.registrationPhone}`} className="block bg-storm-red hover:bg-storm-red-dark transition-colors text-white p-6 rounded-xl mb-3 group" data-id="element-3222">
                  <div className="flex items-center gap-3 mb-1" data-id="element-3223">
                    <Phone className="w-5 h-5" data-id="element-3224" />
                    <span className="font-bold text-sm uppercase tracking-wide" data-id="element-3225">
                      Call
                    </span>
                  </div>
                  <p className="font-display text-3xl tracking-wide" data-id="element-3226">
                    {CAMP_SEASON.registrationPhone}
                  </p>
                </a>

                <a href={`sms:${CAMP_SEASON.registrationPhone.replace(/-/g, '')}`} className="block bg-ink hover:bg-charcoal transition-colors text-white p-6 rounded-xl mb-3" data-id="element-3227">
                  <div className="flex items-center gap-3 mb-1" data-id="element-3228">
                    <MessageSquare className="w-5 h-5 text-storm-red" data-id="element-3229" />
                    <span className="font-bold text-sm uppercase tracking-wide" data-id="element-3230">
                      Text
                    </span>
                  </div>
                  <p className="font-display text-3xl tracking-wide" data-id="element-3231">
                    {CAMP_SEASON.registrationPhone}
                  </p>
                </a>

                <a href={`mailto:${CAMP_SEASON.registrationEmail}`} className="block bg-off-white hover:bg-subtle-gray transition-colors text-ink p-4 rounded-xl border border-subtle-gray" data-id="element-3232">
                  <div className="flex items-center gap-3" data-id="element-3233">
                    <Mail className="w-5 h-5 text-storm-red" data-id="element-3234" />
                    <div data-id="element-3235">
                      <span className="font-bold text-xs uppercase tracking-wide text-gray-warm block" data-id="element-3236">
                        Email
                      </span>
                      <p className="font-bold text-sm text-ink break-all" data-id="element-3237">
                        {CAMP_SEASON.registrationEmail}
                      </p>
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}